import React from 'react'
import { ToastContainer } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import UseEditState from './Hooks/useEditState';
const EditState = () => {
    const {
        countryData,
        spinner,
        stateEdit
    } = UseEditState()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Edit State
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={stateEdit.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Country Code *</label>
                            <select className="form-select"
                                name='countryName'
                                onChange={stateEdit.handleChange}
                                value={stateEdit.values.countryName}>
                                <option value='' selected disabled hidden>Select Country Code</option>
                                {
                                    countryData?.map((item) =>
                                        <option value={item._id} key={item._id}>{item.name}({item.code})</option>
                                    )
                                }
                            </select>
                            {stateEdit.touched.countryName && stateEdit.errors.countryName ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {stateEdit.errors.countryName}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">State Code *</label>
                            <input type="text" className="form-control"
                                name='code'
                                onChange={stateEdit.handleChange}
                                value={stateEdit.values.code}
                            />
                            {stateEdit.touched.code && stateEdit.errors.code ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {stateEdit.errors.code}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">State *</label>
                            <input type="text" className="form-control"
                                name='name'
                                onChange={stateEdit.handleChange}
                                value={stateEdit.values.name}
                            />
                            {stateEdit.touched.name && stateEdit.errors.name ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {stateEdit.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <p>* Note : Please fill all the mandatory fields</p>
                        < div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default EditState